<template>
    <div class="container justify-content-md-center">
        <div class="row align-items-center">
            <div class="offset-md-1 col-md-6 col-sm-12">
                <div v-if="state === 0"> 
                    <!-- Alert for Notification -->
                    <br/>
                    Waiting Notification Premission
                </div>
                <div v-if="state === 1"> 
                    <!-- Waiting FCM -->
                    <br/>
                    Waiting FCM
                </div>
                <div v-if="state === 2"> 
                    <!-- Complete -->
                    <h2>Message Setting</h2>
                    <div class="container">
                        <div class="row">
                            <div class="col-6">
                                Notification
                            </div>
                            <div class="col-6">
                            <div class="togglebutton">
                            <label>
                                <input type="checkbox" name="notification" v-model="notification" :disabled="notification_dis">
                                <span class="toggle"></span>
                            </label>
                            </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                Show Message Content
                            </div>
                            <div class="col-6">
                            <div class="togglebutton">
                            <label>
                                <input type="checkbox" name="preview" v-model="preview" :disabled="preview_dis">
                                <span class="toggle"></span>
                            </label>
                            </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="offset-2 col-10">
                                <br/>
                                <button class="btn btn-rose btn-round" @click="$router.push({name:'logout'})">Logout</button>
                            </div>
                        </div>
                    </div>
                </div>    
            </div>
            <div class="col-md-5 col-sm-12">
                
                
            </div>   
        </div> 
    </div>        
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/messaging';

var messaging = firebase.messaging();
export default {
  name: "push-component",
  data() {
      return {
          status:'',
          state:0,
          preview:true,
          notification:true,
          notification_dis:true,
          preview_dis:true
      }
  },
  methods: {
    retrieveToken() {
      messaging
        .getToken()
        .then(currentToken => {
          if (currentToken) {
           // this.fcmId = currentToken;
            this.$util.log("get fcm_id:"+currentToken);
            this.status = "success ["+currentToken+"]"
            this.updateFcmId(currentToken)
            this.state = 2;
          } else {
            // Show permission request.
            console.log("No Instance ID token available. Request permission to generate one.");
            this.status ="No Instance ID token available. Request permission to generate one.";
            this.state = 3;
            // Show permission UI.
          }
        })
        .catch(function(err) {
          console.log("An error occurred while retrieving token. ", err);
          this.status ="An error occurred while retrieving token. ";
          this.state = 3;
          // showToken("Error retrieving Instance ID token. ", err);
          // setTokenSentToServer(false);
        });
    },
    async updateFcmId(currentToken) {
        const response = await this.$client.updateFcm(currentToken);
    },
    async saveNotification(){
        this.notification_dis = true;
        const data = {
            set_notification:this.notification,
            set_show_preview:this.preview
        }
        const response = await this.$client.setSetting(data);
        this.notification_dis = false;
    },
    async savePreview(){
        this.preview_dis = true;
        const data = {
            set_notification:this.notification,
            set_show_preview:this.preview
        }
        const response = await this.$client.setSetting(data);
        this.preview_dis = false;
    },
    async getSetting(){
        const setting = this.$util.loadLocalstorage('setting',{
             set_notification:'true',
             set_show_preview:'true'
        });
        this.renderSetting(setting);
        const data = {
            set_notification:this.notification,
            set_show_preview:this.preview
        }
        const response = await this.$client.getSetting();
        this.$util.saveLocalStorage('setting',response);
        this.renderSetting(response);
        this.notification_dis = false;
        this.preview_dis = false;
    },
    renderSetting(data) {
        if (data === undefined) return;
        if ( data.set_notification !== null )
            this.notification = data.set_notification;
        if ( data.set_show_preview !== null )
            this.preview = data.set_show_preview;
    }
  },
  mounted() {
    messaging
      .requestPermission()
      .then(() => {
        console.log("Notification permission granted.");
        this.retrieveToken();
        this.state = 1;
        // TODO(developer): Retrieve an Instance ID token for use with FCM.
        // ...
      })
      .catch(function(err) {
        console.log("Unable to get permission to notify.", err);
        this.state = 3;
      });

    this.getSetting();
  },
  watch:{
      notification:{
        handler: function(val, oldVal) {
            this.saveNotification();
        }
      },
      preview:{
        handler: function(val, oldVal) {
            this.savePreview();
        }
      }
  }
};
</script>

<style scoped>
.green {
    color:#7ed321
}
.material-icons.md-36 {
   font-size: 30px;
   display: inline-flex;
   vertical-align: middle;
   padding-bottom:10px;
   margin-right:5px;
  }
.complete{
    font-size: 1.25rem;
    line-height: 1.5em;
}
.toggle-button-green {
    background-color:rgba(126, 211, 33, 0.7) !important
}
</style>
